import React from 'react'
import { confirmationInstructionData, detailInstructionData } from './data'
import { rmaLRPage } from '../../constant'
import {
  TimelineBullet,
  TimelineContainer,
  TimelineContent,
  TimelineDetail,
  TimelineInstruction,
} from './style/Timeline.css'

const Instruction = ({ type, item }) => {
  const { itemTotal } = { ...item }
  const { header, list } = type === rmaLRPage.detail
    ? detailInstructionData
    : confirmationInstructionData

  return (
    <TimelineInstruction>
      <h4>{header}</h4>
      <TimelineContainer>
        {
          list.map(({ Detail }) => (
            <TimelineContent key={Math.random()}>
              <TimelineBullet>
                <TimelineDetail>
                  <Detail itemTotal={itemTotal} />
                </TimelineDetail>
              </TimelineBullet>
            </TimelineContent>
          ))
        }
      </TimelineContainer>
    </TimelineInstruction>
  )
}

export default Instruction
